import React from 'react';
class KopfLayoutBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
   
    this.state = {
      suchesichtbar : false,
      mobilesichtbar : false
    };
    this.gotoSuche = this.gotoSuche.bind(this);
    this.toggleSearchBar = this.toggleSearchBar.bind(this);
  }

  gotoSuche(e) {

    this.setState({suche: this.suche.value});
    if (e.key === 'Enter') {
     
      if (typeof window !== 'undefined') {
          window.location.href = "https://odernichtoderdoch.de/addons/rezepte/search/" + encodeURI(this.suche.value);
      }
    }
  }
  goToAnsicht(category) {
    if (category !== undefined) {
      window.location.href = "https://rezepte.odernichtoderdoch.de/?c=" + encodeURI(category);
  }
  }
  toggleSearchBar(e) {
    
    e.preventDefault();
    let mobilesichtbar = this.state.mobilesichtbar;
    
    if(this.state.mobilesichtbar === true) {
      mobilesichtbar =  false;
    } else {
       mobilesichtbar = true;
    }
    this.setState({ mobilesichtbar: mobilesichtbar });
  }
  toggleMobileBar(e) {
    e.preventDefault();
    let mobilesichtbar = this.state.mobilesichtbar;
    
    if(this.state.mobilesichtbar === true) {
      mobilesichtbar =  false;
    } else {
       mobilesichtbar = true;
    }
    this.setState({ mobilesichtbar: mobilesichtbar });
  }
  render() {
    let mobileMenuClass = ((this.state.mobilesichtbar === true) ? 'mobilenavOverlay open' : 'mobilenavOverlay');
    return (
    <div>
      <nav id="main">
        <div className='navigation-button'>
          <ul>
            <li className="link"><a href="//www.odernichtoderdoch.de/" className="btn stdrose">Zurück zum Shop</a></li>
            <li className="mobile" ><a href="#mobile" onClick={ (e) => this.toggleMobileBar(e) }>#</a></li>
          </ul>
        </div>  
        <div className="onod-logo">
        <a href="//rezepte.odernichtoderdoch.de"><img className="navlogo" src="/images/odernichtoderdoch_logo.svg" alt="Logo" /></a>
        </div>
      </nav>
    <div className={mobileMenuClass} id="mobileOverlay">
      <div className="close" onClick={ (e) => this.toggleMobileBar(e) }><a className="closebutton"><img className="icon" src="/images/i_close.svg" alt=""/></a></div>
      <ul className="mobile">
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('alle') } ><img className="icon" src="/images/i_alles.svg"  alt="Alles"/>Alles</li>
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('vorspeisen') } ><img className="icon" src="/images/i_vorspeise.svg" alt="Vorspeise"/>Vorspeise</li>
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('hauptgaenge') } ><img className="icon" src="/images/i_hauptgang.svg" alt="Hauptgang"/>Hauptgang</li>
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('dessert') } ><img className="icon" src="/images/i_dessert.svg" alt="Dessert"/>Dessert</li>
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('gebaeck') } ><img className="icon" src="/images/i_backen.svg" alt="Backen"/>Backen</li>
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('snacks') } ><img className="icon" src="/images/i_snacks.svg" alt="Snacks"/>Snacks</li>
        <li className='logicSelectRecieptsLink' onClick={ (e) => this.goToAnsicht('getraenke') } ><img className="icon" src="/images/i_getraenke.svg" alt="Getränke"/>Getränke</li>
      </ul>
      <ul className="mobile2">
        <li><img className="icon" src="/images//i_neuesrezept.svg" alt="Rezept schreiben"/>Rezept schreiben</li>
      </ul>
      <ul className="mobile3">
        <li><a>Zurück zum Shop</a></li>
      </ul>
      <ul className="social">
        <li className="social"><a> <img className="icon" src="/images/i_facebook.svg" alt="Facebook"/></a></li>
        <li><a> <img className="icon" src="/images/i_instagram.svg" alt="Instagram"/></a></li>
      </ul>
    </div>
    <header className="home erfassung">
      <div className="headercontent"><a href="//rezepte.odernichtoderdoch.de"><img className="headertitle" src="/images//heldentitel.svg" alt="Heldenküche" /></a>
        <h1 className="white">Werde Teil unseres Community-Kochbuchs</h1>
      </div>
    </header>
  </div>
     );
  }
}
export default KopfLayoutBlock;


// WEBPACK FOOTER //
// ./src/KopfLayoutBlock.js